import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import SpIconButton from "../../atoms/SpIconButton";
import { DirectionsBike } from "@material-ui/icons";

const Wrapper = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	min-width: 100px;
	width: 18px;
	height: 18px;
	background-color: #000 !important;
	border: 2px solid #fff;
	border-radius: 100%;
	user-select: none;
	transform: translate(-50%, -50%);
	cursor: ${(props) => (props.onClick ? "pointer" : "default")};
	&:hover {
		z-index: 1000;
	}
`;

const SpGoogleMarker = ({ text, onClick, type }) => (
	<SpIconButton onClick={onClick}>
		<DirectionsBike />
	</SpIconButton>
);

SpGoogleMarker.defaultProps = {
	onClick: null,
};

SpGoogleMarker.propTypes = {
	onClick: PropTypes.func,
	text: PropTypes.string.isRequired,
};

export default SpGoogleMarker;
